'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import HR from 'UIComponents/elements/HR';
import UIFlex from 'UIComponents/layout/UIFlex';
import classNames from 'classnames';

const TextHR = (_ref) => {
  let {
    children,
    className
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  return /*#__PURE__*/_jsxs(UIFlex, Object.assign({
    className: classNames('p-x-10', className)
  }, restProps, {
    children: [/*#__PURE__*/_jsx(HR, {
      className: "m-right-3",
      distance: "small"
    }), children, /*#__PURE__*/_jsx(HR, {
      className: "m-left-3",
      distance: "small"
    })]
  }));
};

TextHR.propTypes = Object.assign({
  children: PropTypes.node
}, UIFlex.propTypes);
TextHR.defaultProps = Object.assign({}, UIFlex.defaultProps, {
  align: 'center'
});
export default TextHR;